import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import SolimoesLogo from "./SolimoesLogo";
import { LogOut, LayoutDashboard, Users, Building2, Stethoscope, Wallet, FileBarChart2, Briefcase, ClipboardList, BadgePercent, MapPin } from "lucide-react";

const NAV = {
  cliente: [
    { to: "/painel/cliente", icon: Wallet, label: "Carteira", end: true },
    { to: "/painel/cliente/rede", icon: MapPin, label: "Rede Credenciada" },
  ],
  credenciado: [
    { to: "/painel/credenciado", icon: ClipboardList, label: "Atendimentos", end: true },
    { to: "/painel/credenciado/registrar", icon: Stethoscope, label: "Registrar atendimento" },
  ],
  vendedor: [
    { to: "/painel/vendedor", icon: LayoutDashboard, label: "Visão Geral", end: true },
    { to: "/painel/vendedor/leads", icon: Briefcase, label: "Leads & Pipeline" },
  ],
  gestor: [
    { to: "/painel/gestor", icon: LayoutDashboard, label: "Visão Geral", end: true },
    { to: "/painel/gestor/rede", icon: Stethoscope, label: "Rede Credenciada" },
    { to: "/painel/gestor/empresas", icon: Building2, label: "Empresas (B2B)" },
    { to: "/painel/gestor/clientes", icon: Users, label: "Clientes" },
    { to: "/painel/gestor/financeiro", icon: BadgePercent, label: "Financeiro" },
    { to: "/painel/gestor/relatorios", icon: FileBarChart2, label: "Relatórios" },
  ],
};

const ROLE_LABEL = {
  cliente: "Cliente",
  credenciado: "Credenciado",
  vendedor: "Vendedor",
  gestor: "Gestor",
};

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const items = NAV[user?.role] || [];

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex">
      <aside className="hidden lg:flex w-72 bg-white border-r border-slate-100 flex-col py-6" data-testid="dashboard-sidebar">
        <div className="px-6 pb-6 border-b border-slate-100">
          <SolimoesLogo className="h-11 w-auto" />
        </div>
        <div className="px-6 pt-5 pb-3">
          <div className="text-xs uppercase tracking-widest font-bold text-[#2A8FE0]">{ROLE_LABEL[user?.role] || "Painel"}</div>
          <div className="font-display text-lg font-bold text-[#0E2A5C] truncate">{user?.name}</div>
          <div className="text-xs text-slate-500 truncate">{user?.email}</div>
        </div>
        <nav className="mt-2 flex-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`nav-${it.to.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-3 font-medium transition-colors ${
                  isActive ? "bg-blue-50 text-[#2A8FE0] border-r-4 border-[#2A8FE0]" : "text-slate-600 hover:bg-slate-50 hover:text-[#2A8FE0]"
                }`
              }
            >
              <it.icon className="h-5 w-5" />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="px-6 pt-4 border-t border-slate-100">
          <button onClick={() => { logout(); navigate("/"); }} className="w-full flex items-center gap-2 px-4 py-2 rounded-full text-slate-600 hover:bg-slate-100 hover:text-[#0E2A5C] transition" data-testid="logout-button">
            <LogOut className="h-4 w-4" /> Sair
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <header className="sticky top-0 z-40 bg-white border-b border-slate-100 px-6 py-4 flex items-center justify-between" data-testid="dashboard-header">
          <div className="lg:hidden"><SolimoesLogo className="h-9 w-auto" /></div>
          <div className="hidden lg:block">
            <div className="font-display text-2xl font-bold text-[#0E2A5C]">Olá, {user?.name?.split(" ")[0]}</div>
            <div className="text-sm text-slate-500">Bem-vindo ao seu painel Solimões Card</div>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full bg-blue-50 text-[#2A8FE0]" data-testid="role-badge">
              {ROLE_LABEL[user?.role]}
            </span>
            <button onClick={() => { logout(); navigate("/"); }} className="lg:hidden inline-flex items-center gap-1 text-sm text-slate-600 hover:text-[#0E2A5C]" data-testid="logout-mobile">
              <LogOut className="h-4 w-4" /> Sair
            </button>
          </div>
        </header>
        <main className="p-6 lg:p-10 max-w-[1400px] mx-auto" data-testid="dashboard-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
